var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 297.357,
    height: 317.067,
    viewBox: "0 0 297.357 317.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 56.344,
    y: 0.941,
    width: 185.119,
    height: 185.119,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 56.344,
    y: 130.235,
    width: 185.119,
    height: 185.119,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 0,
    y: 0,
    width: 297.357,
    height: 317.067,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    transform: "translate(.003 .001)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 61",
    cx: 62.56,
    cy: 62.56,
    transform: "translate(86.34 20.94)",
    fill: "#39beec",
    r: 62.56
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)",
    transform: "translate(.003 .001)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 62",
    cx: 62.56,
    cy: 62.56,
    transform: "translate(86.34 150.24)",
    fill: "#1b60a3",
    r: 62.56
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.003 -.004)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1968",
    d: "m204.187 227.245 8.381-8.383h-11.28V77.044h10.036l-7.212-7.21 39.224-39.224 13.343 13.342-36.521 36.524v136.052l36.595 36.595-13.343 13.342ZM40.61 253.105l36.586-36.588v-136L40.64 43.967l13.346-13.345L93.21 69.845l-7.2 7.2h10.057v141.816H84.81l8.363 8.366-39.221 39.22Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/Bridge.7d54968bc434ed7ec725e079d1d5d577.svg";
export { ForwardRef as ReactComponent };